var map = {
	"./amex@1x.png": "40e7",
	"./diners@1x.png": "46cd",
	"./discover@1x.png": "c094",
	"./jcb@1x.png": "803e",
	"./mastercard@1x.png": "829b",
	"./unionpay@1x.png": "2dbc",
	"./visa@1x.png": "2f80"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d869";